import './Header.scss'


function Header() {

    return (
        <>
            <header className="hero__image">
                <h1 className="hero__text">your next adventure starts right on your doorstep</h1>
            </header>
        </>

    );
}

export default Header;






